import React, {Component} from 'react';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import tableBaseTheme from '../../theme/tableBaseTheme';
import _ from 'lodash';
import { STRIPE_KEY, COST, CURRENCY } from 'constants/stripe';
import {StripeProvider, Elements} from 'react-stripe-elements';
import StripeCheckout from 'react-stripe-checkout';
import {inject, observer} from 'mobx-react';
import HttpClient from 'services/HttpClient';
import { withRouter } from 'react-router-dom';
import CardForm from './CardForm';
import {SubscribeButton} from './SubscribeButton';

const SUBSCRIPTIONS = '/api/v1/subscriptions';
const TOPICS_REQUEST = '/api/v1/tutorials?';

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table';
import moment from 'moment'

const RED = '#E53935';
const YELLOW = '#FBC02D';
const GREEN = '#43A047';
const BLUE = '#0085c5';
const SUBSCRIPTION_CREATE = '/api/v1/subscriptions';
const COURSE_REQUEST = '/api/v1/courses';

@withRouter
@inject('userStore')
@inject('alertStore')
@inject('courseStore')
@inject('topicsStore')
@observer
class PaymentsSettings extends Component {
  constructor() {
    super();

    this.state = {
      fixedHeader: true,
      stripedRows: false,
      showRowHover: false,
      selectable: true,
      multiSelectable: false,
      enableSelectAll: false,
      deselectOnClickaway: true,
      showCheckboxes: false,
      active: false,
      buttonText: '€ 595 – Purchase',
      payments: [],
      closestCourse: {},
      isStripeOpened: false,
      tutorial_id: null,
      title: 'An',
    };
  }

  handleChange = (event) => {
    this.setState({height: event.target.value});
  };

  onToken = e => {
    const { closestCourse } = this.props.courseStore;
    const {tutorial_id} = this.state;

    return new HttpClient().post(SUBSCRIPTION_CREATE, {
      token: e.id,
      course_id: closestCourse.id,
      tutorial_id,
      subs_type: 0,
    });
    // .then(() => {
    //   this.props.alertStore.success('Transaction pending');
    //   this.props.history.push(`'/exam-prep/topic/'${tutorial_id}`)
    // }).catch(() => {
    //   this.props.alertStore.success('Something went wrong');
    // });
  };

  updatebuttonText = () => {
    let newState = _.assign({}, this.state, {buttonText: 'Pending'});
    this.setState(newState);
  };

  componentWillMount = () => {
    const { userStore, topicsStore } = this.props;
    const isExamPrepUser = userStore.isExamPrepUser();

    new HttpClient().get(SUBSCRIPTIONS).then(data => {
      if(data.body.data.transctions)
        this.setState({payments: data.body.data.transctions, active: data.body.data.active})
    });
    new HttpClient().get(COURSE_REQUEST).then(response => {
      // const now = new Date().setHours(0,0,0,0);
      let closest = {};

      response.body.data.courses.forEach(course => {
        // const on_site_date = new Date(course.on_site_date).setHours(0,0,0,0);
        const off_site_date = new Date(course.off_site_date).setHours(0,0,0,0);

        if(closest.on_site_date) {
          if(new Date(closest.off_site_date).setHours(0,0,0,0) < off_site_date) {
            closest = course;
          }
        } else {
          closest = course;
        }
      });

      this.setState({ closestCourse: closest });
      this.props.courseStore.setCourses(response.body.data.courses);
      this.props.courseStore.setCourse(closest);
    })

      if (isExamPrepUser && !userStore.isAdmin()) {
        new HttpClient().get(`${TOPICS_REQUEST}tutorial_types[]=1&tutorial_types[]=2`).then(response => {
          topicsStore.setTopics(response.body.data.tutorial);
        });
      }
  };

  getColor = type => {
    let color;
    switch(type){
      case 'pending':
        color = YELLOW;
        break;
      case 'success':
        color = GREEN;
        break;
      case 'failed':
        color = RED;
        break;
      case 'refunded':
        color = BLUE;
        break;
    }
    return color;
  };

  handleStripeModal = () => {
    this.setState({isStripeOpened: !this.state.isStripeOpened});
  }

  handleExamStripeModal = tutorial => {
    this.setState({isStripeOpened: !this.state.isStripeOpened, tutorial_id: tutorial.id, title: tutorial.title});
  }

  render() {
    const { closestCourse, isStripeOpened, title } = this.state;
    const { userStore, topicsStore } = this.props;
    const { clearTopics } = topicsStore;
    console.log(window.innerWidth)
    const isMobile = window.innerWidth < 568;

    return (
      <div className="pricing-wrap payments">
        { _.isEmpty(this.state.payments) ||
        <MuiThemeProvider muiTheme={getMuiTheme(tableBaseTheme)} key={3}>
          <Table
            height={this.state.height}
            fixedHeader={this.state.fixedHeader}
            fixedFooter={this.state.fixedFooter}
            selectable={this.state.selectable}
            multiSelectable={this.state.multiSelectable}
          >
            <TableHeader
              displaySelectAll={this.state.showCheckboxes}
              adjustForCheckbox={this.state.showCheckboxes}
              enableSelectAll={this.state.enableSelectAll}
            >
              <TableRow key='1321'>
                <TableHeaderColumn key={1} style={{width: '35%'}}>Course</TableHeaderColumn>
                <TableHeaderColumn key={2} style={{width: '20%', textAlign: isMobile ? 'center' : 'right'}}>{isMobile ? 'Date' : 'Payment Date'}</TableHeaderColumn>
                <TableHeaderColumn key={2} style={{width: isMobile ? '20%' : '25%'}}>Access Ends</TableHeaderColumn>
                <TableHeaderColumn key={3} style={{width: '10%'}}>Cost</TableHeaderColumn>
                <TableHeaderColumn key={4} style={{width: isMobile ? '15%' : '10%'}}>Status</TableHeaderColumn>
              </TableRow>
            </TableHeader>
            <TableBody
              displayRowCheckbox={this.state.showCheckboxes}
              deselectOnClickaway={this.state.deselectOnClickaway}
              showRowHover={this.state.showRowHover}
              stripedRows={this.state.stripedRows}
            >
              {this.state.payments.map((row, index) => (
                <TableRow key={index}>
                  <TableRowColumn key={1} style={{width: '35%'}}>{row.course ? row.course.title : (row.tutorial_title || (userStore.isExamPrepUser() ? 'MICGP CKT EXAM PREP' : 'Prescription Revision Online'))}</TableRowColumn>
                  <TableRowColumn key={2} style={{width: '20%'}}>{`${moment(row.start_date, 'DD-MM-YYYY').format(isMobile ? 'DD/MM/YY' : 'DD/MM/YYYY')}`}</TableRowColumn>
                  <TableRowColumn key={1} style={{width: isMobile ? '20%' : '25%'}}>{row.end_date ? `${moment(row.end_date, 'DD-MM-YYYY').format(isMobile ? 'DD/MM/YY' : 'DD/MM/YYYY')}` : `${moment(row.start_date, 'DD-MM-YYYY').add(1, 'y').format(isMobile ? 'DD/MM/YY' : 'DD/MM/YYYY')}`}</TableRowColumn>
                  <TableRowColumn key={3} style={{width: '10%'}}>€ {row.amount / 100}</TableRowColumn>
                  <TableRowColumn key={4} style={{width: isMobile ? '15%' : '10%', color: this.getColor(row.status), textTransform: 'capitalize'}}>{row.status}</TableRowColumn>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </MuiThemeProvider>
          }
        { !closestCourse.is_purchased &&
          <div className="not-payed-wrap">
            {/* <div className="top-block">
              <div className="price">{`€ ${ this.state.closestCourse.price || '160' }`}</div>
              <div className="title">{
                this.state.closestCourse.title || ''
              }</div>
            </div> */}
            {/* <div className="desc">Unlimited access until {moment(new Date()).add(1, 'y').format('DD/MM/YYYY')}</div> */}
            {userStore.isExamPrepUser() && !userStore.isAdmin() ? null : (
              <div className="top-block">
                <div className="desc">An annual subscription costs € 595</div>
              </div>
            )}
            {/* <StripeCheckout
              email={this.props.userStore.user.email}
              panelLabel="Submit payment"
              stripeKey={STRIPE_KEY}
              amount={COST}
              allowRememberMe={false}
              currency={CURRENCY}
              token={this.onToken}
            > */}
            <div className='row'>
              {userStore.isExamPrepUser() && !userStore.isAdmin() ?
              // (
                // <div className="row">
                //   {clearTopics.map(topic => (
                //     <SubscribeButton key={topic.id} topic={topic} onClick={this.handleExamStripeModal} />
                //   ))}
                //   {/* <button className="btn rounded blue purchase-btn" onClick={this.handleCctStripeModal}>{this.state.cctButtonText}</button> */}
                // </div>
              // )
              null : (
                <button className="btn rounded blue purchase-btn" onClick={this.handleStripeModal}>{this.state.buttonText}</button>
              )}
            </div>
            {/* </StripeCheckout> */}
          </div>
        }
        <StripeProvider apiKey={STRIPE_KEY}>
          <Elements>
            <CardForm
              onToken={this.onToken}
              cost={this.state.buttonText}
              hideStripeModal={this.handleStripeModal}
              showStripeModal={isStripeOpened}
              email={userStore.user.email}
              title={title}
            />
          </Elements>
        </StripeProvider>
      </div>
    );
  }
}

export default PaymentsSettings;



// WEBPACK FOOTER //
// ./src/modules/profile/components/PaymentsSettings.js